<ui-checkbox
    *ngIf="!isMobileShowcase"
    (click)="onSelect($event)"
    class="checkbox"
    [id]="'interaction-creative-checkbox-' + index"
    [selected]="(selected$ | async) ?? false">
</ui-checkbox>
